<template>
  <WCard
    v-if="props.content"
    shadow
    :bordered="false"
    class="begginingOfOurStory"
    textClass="begginingOfOurStory__textClass"
    titleClass="mb-0"
  >
    <WStoryLayout
      :items="beginningOfOurStoryItems"
      :logoWithTitle="true"
      :expandable="true"
      expandButtonColor="var(--bs-mint-500)"
      titleUnderlineColor="var(--bs-mint-500)"
      class="text-center"
    ></WStoryLayout>
  </WCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { components } from '@/types'
import type { StoryLayoutItem } from '@wiosna-dev/wiosna-ui/types'

interface Props {
  content: components['schemas']['ChildEdition2']['beginning_of_our_story_child_choice_path']
}
const props = defineProps<Props>()

const { t } = useI18n()
const beginningOfOurStoryItems = computed<StoryLayoutItem[]>(() => [
  {
    logo: 'swdBusStopPresentIcon',
    title: t('childPage.begginingOfOurStory.busStopPresent'),
    content: props.content?.busStopPresent ?? ''
  },
  {
    logo: 'swdBusStopChallengesIcon',
    title: t('childPage.begginingOfOurStory.busStopChallenges'),
    content: props.content?.busStopChallenges ?? ''
  }
])
</script>
<style lang="scss">
.begginingOfOurStory {
  .m-wStoryLayout__mobileSection {
    // overwrite bootstraps margin important
    margin: 0 !important;

    // add horizontal line after first element on mobile
    .col-12:nth-child(1)::after {
      content: '';
      width: 100%;
      height: 1px;
      display: block;
      background-color: var(--bs-border);
    }
  }

  &__textClass {
    display: flex;
    justify-content: center;
    margin-bottom: 0;
  }
}
</style>
